<template>
  <div class="container-fluid pt-5">
    <div class="d-flex justify-content-center mt-5">
      <rebalance-form class="col-lg-12"></rebalance-form>
    </div>

    <b-modal
      v-model="showModal"
      title="Successful submit"
      header-bg-variant="success"
      header-text-variant="light">
      <div slot="modal-header-close"></div>
      <p>The transactions were submitted successfully.</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="redirect">OK</b-btn>
      </div>
    </b-modal>
  </div>
</template>


<script>
  import RebalanceForm from '../components/forms/RebalanceForm'

  export default {
    components: {
      rebalanceForm: RebalanceForm,
    },
    data() {
      return {
        showModal: false,
      }
    },
    methods: {
      redirect() {
        this.showModal = false
        this.$router.push('/')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/RebalancePage.vue